import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import Feature from '../common/Feature';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

import Hero from './common/Hero';
import TrustedSection from './common/TrustedSection';
import TopProducts from './common/TopProducts';
import TrustSection from './common/TrustSection';
import TotalProductCount from './common/TotalProductCount';

class Category extends Component {
	render() {
		const pageTitle = 'Pistol Safes';
		const totalCount = this.props.category.productCount;
		let topProducts;
		// eslint-disable-next-line eqeqeq
		if (this.props.featuredProduct != null) {
			topProducts = (
				<TopProducts
					title={ `Best Selling ${pageTitle}` }
					subTitle="Quick access when you need your firearm. Safe storage when you don&rsquo;t."
					path="pistol-safes"
					buttonCTA={ `View all ${pageTitle}` }
					topProduct={ this.props.featuredProduct }
				/>
			);
		}

		return (
			<div className="category category-pistol">
				<Helmet>
					<title>Gun &amp; Pistol Safes &#124; SentrySafe</title>
					<meta name="description" content="SentrySafe Pistol Safes protect your guns from unauthorized access and theft with durable solid steel construction and advanced locking systems. View Gun Safes." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem path="/products" label="Products" />
					<BreadcrumbItem label={ pageTitle } />
				</Breadcrumb>

				<Hero
					imageSrc={ require('../../resources/img/hero/pistol-safes.jpg') }
					imageAlt="Father and daughter reading"
					title={ pageTitle }
					description="Quick access security for your home defense needs."
				/>

				<TrustedSection
					content="SentrySafe <b>Pistol Safes</b> are designed with advanced security features to provide proper storage and protection for your <b>guns and pistols</b>. Built with solid steel construction our <b>gun safes</b> are durable enough to protect against unauthorized access and theft. Advanced locking technology, compression gas struts and interior lighting features offer discreet access to your <b>handguns</b> when you need it most. Our <b>Pistol Safes</b> are available in a variety of sizes and unique locking features to meet your needs."
				/>

				{ topProducts }

				<TrustSection
					title={ 'Where Safety and Access Meet' }
					subTitle="SentrySafe Pistol Safes deliver assurance to gun owners that they will have quick, reliable access to their firearm when it matters most. With options for whisper&#45;quiet entry, biometric &#40;fingerprint&#41; access and portable security, our safes are on the leading&#45;edge of tactical firearm storage."
				/>

				<section className="row features">
					<div className="col sm-12">
						<h2 className="title">Features Built for Protection</h2>
					</div>
					<div className="callouts">
						<Feature
							title="Steel Tether Cable"
							description="For securing your safe to other fixed objects."
							image={ require('../../resources/img/features/tether-cable.png') }
						/>
						<Feature
							title="Zero-Feedback Backlit Digital Keypad and Whisper-Quiet Gas Strut"
							description="When discreet access matters."
							image={ require('../../resources/img/features/zero-feedback.png') }
						/>
						<Feature
							title="Fingerprint Entry"
							description="Biometric technology detects your fingerprint, allowing for quick, single-hand access when you need it."
							image={ require('../../resources/img/features/biometric-lock.png') }
						/>
						<Feature
							title="Single-Handed Access"
							description="Compression gas strut holds the lid open for reliable, single&#45;hand access."
							image={ require('../../resources/img/features/quick-entry.png') }
						/>
						<Feature
							title="Solid Steel Construction"
							description="Durable enough to keep valuable firearms protected."
							image={ require('../../resources/img/features/steel-construction.png') }
						/>
					</div>
				</section>

				<TotalProductCount
					link="pistol-safes"
					productTotal={ totalCount }
					name={ pageTitle }
				/>
			</div>
		);
	}
}

export default branch({
	category: ['category'],
	featuredProduct: ['category', 'featuredProduct', 'products']
}, Category);


// WEBPACK FOOTER //
// ./src/pages/category/PistolCategory.js